import React from "react";

import { StyleSheet } from "react-native";
import { palette } from "../styles";
import Block from "./Block";
import Button from "./Button";
import LinePlaceholder from "./LinePlaceholder";
import SvgIcon from "./SvgIcon";
import Typography from "./Typography";

type Props = {
  rating?: number;
  numberOfReviews?: number;
  type?: "primary" | "white" | "secondary";
  openReviews?: () => void;
  t: NotWorth;
  loading?: boolean;
};

const iconColor = {
  primary: palette.primary.accent,
  white: palette.common.white,
  secondary: palette.secondary.pink,
} as const;

const textColor = {
  primary: palette.common.black,
  white: palette.common.black,
  secondary: palette.common.white,
} as const;

const textVariant = {
  primary: "navLink",
  white: "navLink",
  secondary: "webParagraph",
} as const;

const Rating = ({
  rating = 0,
  numberOfReviews = 0,
  type = "primary",
  openReviews,
  t,
  loading,
}: Props) => {
  const averageRating = `${rating?.toFixed(2)}/5`;
  const amountOfReviews = `(${numberOfReviews}+ ${t("screens.dashboard.testimonials")})`;

  return (
    <>
      <Block alignCenter row marginRight={1}>
        <SvgIcon color={iconColor[type]} name="star" size={20} />

        {loading && (
          <Block justifyCenter marginLeft={1}>
            <LinePlaceholder borderRadius={2.5} height={3} width={10} />
          </Block>
        )}
        {!!rating && (
          <Typography
            variant={textVariant[type]}
            style={[styles.averageRating, { color: textColor[type] }]}
          >
            {averageRating}
          </Typography>
        )}
      </Block>

      {openReviews &&
        (loading ? (
          <LinePlaceholder borderRadius={2.5} height={3} width={20} marginTop={1.5} />
        ) : (
          <Button
            type="link"
            label={`${amountOfReviews}`}
            onPress={openReviews}
            textStyle={{ color: palette.common.black }}
            style={styles.linkButton}
          />
        ))}
    </>
  );
};

export default React.memo(Rating);

const styles = StyleSheet.create({
  amountOfReviews: {
    marginTop: 12,
  },
  averageRating: {
    marginLeft: 8,
    alignSelf: "center",
  },
  linkButton: {
    alignItems: "flex-start",
    marginTop: 12,
  },
});
